const VERSION = "5.0.0";
export {
  VERSION
};
